import React, { ChangeEvent, useEffect, useMemo, useRef } from "react";
import { BaseInput, PInput } from "../BaseInput";
import { UnderlinedText } from "../BaseInput/components";

interface TOtpInput extends PInput {
  value: string[];
  onInputChange: (value: string | string[]) => void;
  length?: number;
}

export const OTPInput: React.FC<TOtpInput> = ({
  errorMessage,
  successMessage,
  helperText,
  value,
  isError,
  onInputChange,
  length = 6,
  ...props
}) => {
  const otpArray = useMemo(() => Array.from({ length }), [length]);

  const itemsRef = useRef<Array<HTMLInputElement | null>>([]);

  useEffect(() => {
    if (itemsRef.current) {
      itemsRef.current[0]?.focus();
    }
  }, []);

  const onKeyDownHandler = (
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    const key = event.key;
    if (itemsRef.current.length) {
      const value = itemsRef.current[index]?.value;
      const isDeleteOperation = key === "Backspace" || key === "Delete";

      if (!value && isDeleteOperation && index > 0) {
        itemsRef.current[index - 1]?.focus();
      }
    }
  };

  const onKeyUpHandler = (
    _: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = itemsRef.current[index]?.value;
    if (value !== "" && index < itemsRef.current.length - 1) {
      itemsRef.current[index + 1]?.focus();
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-row justify-between">
        {otpArray.map((_, index) => (
          <BaseInput
            ref={(el) => {
              // Assign ref, but do not return anything
              itemsRef.current[index] = el;
            }}
            {...props}
            key={index}
            value={value[index]}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              const incomeValue = e.target.value;
              const currentValue = value;
              currentValue.splice(index, 1, incomeValue);
              onInputChange(currentValue);
            }}
            onPaste={(event) => {
              event.preventDefault();
              let valueToUpdate: string[] = [];
              const copiedText = event.clipboardData?.getData("text");
              if (copiedText) {
                valueToUpdate = copiedText.substring(0, length).split("");
                onInputChange(valueToUpdate);
              }
              itemsRef.current[valueToUpdate.length - 1 || length - 1]?.focus();
            }}
            onKeyDown={(event) => {
              props.onKeyDown && props.onKeyDown(event);
              onKeyDownHandler(event, index);
            }}
            onKeyUp={(event) => onKeyUpHandler(event, index)}
            className="[&::-webkit-inner-spin-button]:[-webkit-appearance:none] text-center Title-L 2xl:Title-2XL 4xl:TitLe-3XL text-text-base "
            isError={isError}
            isUnderlinedTextVisible={false}
            errorMessage={errorMessage}
            maxLength={1}
            type="tel"
            wrapperClassName="[&>div]:p-1 w-[50px] 3xl:w-[62px]"
            inputClassName="border-b-[1px] border-t-[0] border-r-0 border-l-0 rounded-none border-primay-1"
          />
        ))}
      </div>
      <UnderlinedText
        isError={!!errorMessage}
        isSuccess={!!successMessage}
        underlinedText={errorMessage || successMessage || helperText}
      />
    </div>
  );
};
